/**
 * @author Designers <designers@wijs.be>
 *
 * @type {{init: Function, bindUIEvents: Function}}
 */
var chopstickFileInput = function () {
    var _inputElement = $(".js-file-input > input");

    _inputElement.on('change', function (e) {
        var files = $(this).prop('files');
        var names = $.map(files, function (val) {
            return val.name;
        });

        $(this).parent().attr("data-text", names.join(', '));
    });
}
